import bizNodeModel from '../../bizNodeModel.mjs'
import ModelAlg from '../_ALG/ModelAlg.mjs'
import StoryType from './StoryType.jsx'

export default bizNodeModel({
    ...ModelAlg.definition,

    algTitle: {
        name: () => '用户场景标题',
    },

    storyType: {
        name: () => '用户场景类型',

        readableValue: (map, node) => {
            const {storyType} = node.data

            if (storyType) {
                const match = StoryType.find(e => storyType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },
})
